import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Card, Box } from "@curves/ui-base";
import CommonTabs from "./CommonTabs";
import Actions from "./Actions";

const TabsCardLayout = ({ className, tabs, activeTab, onTabChange, children, actions, tabsContent, ...others }) => {
	const { className: tabsContentClassName, ...othersTabsContent } = tabsContent || {};
	return (
		<Card className={clsx("tabs-content-layout", className)} {...others}>
			<Box component="header" className="page-header">
				<CommonTabs tabs={tabs} onTabChange={onTabChange} activeTab={activeTab} />
				{actions && <Actions actions={actions} />}
			</Box>
			<Card.CardContent className={clsx(tabsContentClassName)} {...othersTabsContent}>
				{children}
			</Card.CardContent>
		</Card>
	);
};

TabsCardLayout.prototype = {
	...Actions.prototype,
	...CommonTabs.prototype,
	children: PropTypes.node,
	tabsContent: PropTypes.object,
};

export default TabsCardLayout;
